var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-content"},[_c('md-spinner',{attrs:{"md-indeterminate":""}}),_c('span',[_vm._v("Please wait...")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }